/** Hides browser's fetch for testing purposes */
export const navigatorFetch = (input: RequestInfo, init: RequestInit | undefined): Promise<Response> => {
    return fetch(input, init);
};

/** Get cookies of document */
export const getCookie = (): string => document.cookie;
